import labelsData from 'labels';
import { getRuntimeConfig } from 'helpers/runtimeConfig';

export const getLabelOptions = () => {
  const labelName = getRuntimeConfig().env.REACT_APP_WL_NAME;
  const SSOProvider = getRuntimeConfig().env.REACT_APP_SSO_PROVIDER || null;
  const isWL = getRuntimeConfig().env.REACT_APP_IS_WL === '1' || false;
  const loginUrl = getRuntimeConfig().env.REACT_APP_COGNITO_LOGIN_URL;
  const redirectUrl = getRuntimeConfig().env.REACT_APP_LOGIN_REDIRECT_URL;
  const cookieDomain = getRuntimeConfig().env.REACT_APP_COGNITO_COOKIE_DOMAIN;

  return {
    isWL,
    loginUrl,
    redirectUrl,
    cookieDomain,
    ...(SSOProvider && { SSOProvider }),
    ...(labelsData[labelName] || labelsData.dokka),
  };
};
